import { Component } from '@angular/core';

@Component({
    selector: 'app-confirm-changing-rating-system',
    templateUrl: './confirm-changing-rating-system.component.html',
    styleUrls: ['./confirm-changing-rating-system.component.scss'],
    standalone: false
})
export class ConfirmChangingRatingSystemComponent {
  constructor() {}
}
